/*
 * Back Link — Level 2 Alpine component
 *
 * Mirrors the browser's native back button: hijacks the click and calls
 * `window.history.back()`. That fires a popstate event, which Swup's
 * transitions registry (`resources/js/router/transitions.js`) treats as a
 * reverse flip — so the "← Back" link from `/work/{slug}` or
 * `/employees/{slug}` runs the exact same `flip-collapse` morph the
 * browser's back button does.
 *
 * Why `stopImmediatePropagation`: Swup registers a delegated click handler
 * on `document` that intercepts any link matching its `linkSelector` and
 * runs a forward visit — and it does NOT check `event.defaultPrevented`
 * before doing so (see `handleLinkClick` in `swup/dist/Swup.modern.js`).
 * Calling only `preventDefault()` doesn't stop Swup; it just suppresses
 * the browser's native navigation, leaving Swup to race our
 * `history.back()` and usually win with a forward visit to `/about` or
 * `/work`. `stopImmediatePropagation` halts bubbling before the event
 * reaches Swup's document-level listener.
 *
 * The fallback (no prior history) deliberately does NOT stop propagation:
 * we want Swup to pick up the click and animate the forward visit to the
 * index page so the user lands somewhere coherent with a normal
 * transition rather than a bare browser navigation.
 */
export default function backLink() {
    return {
        back(event) {
            if (window.history.length <= 1) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            window.history.back();
        },
    };
}
